import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";
import * as _ from "lodash";


export interface MachineDefectMappingService {
  getMachineDefectMappings(machineName: string, plantId: string, shopId: string): angular.IPromise<apsViewModels.MachineDefectMapping[]>;
  getMachineDefectMappingsForCloning(machineName: string, plantId: string, shopId: string, plantIdDst: string, shopIdDst: string): angular.IPromise<apsViewModels.MachineDefectMapping[]>;
  saveMachineDefectMappings: (machineDefects: angular.IPromise<apsViewModels.MachineDefectMapping[]>) => angular.IPromise<any>;
}

export default angular.module('aps.services.machineDefectMapping', [HttpServiceName])
  .service('machineDefectMappingService', function(httpService: HttpService): MachineDefectMappingService {

    function getMachineDefectMappings(machineName : string, plantId: string, shopId: string) {
      return httpService.get<apsViewModels.MachineDefectMapping[]>(Endpoints.MACHINE_DEFECT_MAPPINGS,  
            {machineName: machineName, plantId: plantId, shopId: shopId});
    }

    function getMachineDefectMappingsForCloning(machineName : string, plantId: string, shopId: string, plantIdDst: string, shopIdDst: string) {
      return httpService.get<apsViewModels.MachineDefectMapping[]>(Endpoints.MACHINE_DEFECT_MAPPINGS_FOR_CLONING,  
            {machineName: machineName, plantId: plantId, shopId: shopId, plantIdDst: plantIdDst, shopIdDst: shopIdDst});
    }

    var saveMachineDefectMappings = function (machineDefects:  angular.IPromise<apsViewModels.MachineDefectMapping[]>) {
      return httpService.post(Endpoints.MACHINE_DEFECT_MAPPINGS, machineDefects);
    };

    return {
      getMachineDefectMappings: getMachineDefectMappings,
      getMachineDefectMappingsForCloning: getMachineDefectMappingsForCloning,
      saveMachineDefectMappings: saveMachineDefectMappings,
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/defects/machineDefectMapping.service.ts